export const userDetails = [
  {
    profileImg: "/Img/auth-img/user1.jpeg",
    name: "Rahul Verma",
    rating: 4.8,
    description:
      "Using Sam Global has been a wonderful experience from the very beginning. The platform is easy to navigate, products are well organized, and the checkout process feels seamless. I appreciate how quickly I can discover new items and trust that every purchase is backed by a reliable marketplace experience.",
  },
  {
    profileImg: "/Img/auth-img/user2.jpeg",
    name: "Arjun Sharma",
    rating: 5,
    description:
      "I have tried many online marketplaces before, but Sam Global stands out because of its smooth user experience and wide range of products. Everything feels thoughtfully designed, from browsing categories to placing orders, making shopping enjoyable, efficient, and dependable whenever I need something new.",
  },
  {
    profileImg: "/Img/auth-img/user3.jpeg",
    name: "Priya Mehta",
    rating: 4.7,
    description:
      "Sam Global has made online shopping much simpler and more convenient for me. The platform offers a great variety of products, clear information, and an intuitive design. I always feel confident exploring different categories, knowing I can find quality items and complete purchases without any hassle.",
  },
  {
    profileImg: "/Img/auth-img/user4.png",
    name: "Aman Gupta",
    rating: 4.9,
    description:
      "What impressed me most about Sam Global is how effortless the entire shopping journey feels. From discovering products to finalizing orders, everything works smoothly and efficiently. The marketplace provides a trustworthy environment where buyers can browse confidently and enjoy a consistent experience every time.",
  },
  {
    profileImg: "/Img/auth-img/user5.jpg",
    name: "Vikram Singh",
    rating: 5,
    description:
      "My experience with Sam Global has been consistently positive. The platform combines ease of use with a diverse selection of products, making it simple to find exactly what I need. Every interaction feels reliable, and the overall shopping experience encourages me to return again and again.",
  },
];
